import { Component, Renderer2, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { RegistrationService } from '../services/registration.service';
import { Message } from 'primeng/components/common/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-paymentlogin',
  templateUrl: './paymentlogin.component.html',
  styleUrls: ['./paymentlogin.component.scss'],
  providers: [ConfirmationService]
})
export class PaymentloginComponent implements OnInit, OnDestroy {

  loginForm: FormGroup;
  forgotpassForm: FormGroup;
  msgs: Message[] = [];
  msgsForgotPass: Message[] = [];
  forgotPassDisplay: boolean=false;
  minDateOfBirth: Date;
  maxDateOfBirth: Date;
  dateOfBirth: Date;
  maxDateOfBirthYear: number;
  minDateOfBirthYear: number;
  otpsuccessmsg:boolean=false;
  fid:any;
  otp:any;
  otpValidation:boolean=false;
  value: any;
  storedDate: any;
  dateMask: any;

  constructor(private renderer: Renderer2, private registrationService: RegistrationService,
    private router: Router,private confirmationService: ConfirmationService,private spinner: NgxSpinnerService) {
      this.renderer.addClass(document.body, 'login-body');
     }

     ngOnInit() {
      const TODAY = new Date();
      const MONTH = TODAY.getMonth();
      const YEAR = TODAY.getFullYear();
  
      this.maxDateOfBirthYear = YEAR - 14;
      this.minDateOfBirthYear = YEAR - 30;
  
      this.minDateOfBirth = new Date();
      this.minDateOfBirth.setMonth(MONTH);
      this.minDateOfBirth.setFullYear(this.minDateOfBirthYear);
  
      this.maxDateOfBirth = new Date();
      this.maxDateOfBirth.setMonth(MONTH);
      this.maxDateOfBirth.setFullYear(this.maxDateOfBirthYear);
  
      this.dateOfBirth = this.maxDateOfBirth;
      localStorage.setItem('authToken','');
      localStorage.setItem('userDetails', '');
      localStorage.setItem('challanList', '');
      
      //localStorage.clear();
      this.loginForm = new FormGroup({
        firstName: new FormControl('', Validators.required),
        dateOfBirth: new FormControl('', Validators.required)
      });
      
    }
  
  
    onSubmit() {
      const data = this.loginForm.value;
      const d = new Date(Date.parse(this.loginForm.value.dateOfBirth));
			if (this.value === undefined) {
				this.storedDate = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
			} else {
				this.storedDate = this.value;
			}
			data.dateOfBirth = this.storedDate;
      if (this.loginForm.valid) {        
        // console.log(data);
        this.registrationService.loginForPayment(data).then(res => {
          if (res.status === 'success') {
            localStorage.setItem('authToken', res.authToken);
            localStorage.setItem('userDetails', JSON.stringify(res.userDetails));
            localStorage.setItem('challanList', JSON.stringify(res.challanlist));
            this.router.navigateByUrl('candidate/onlinepayment');
          } else {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Wrong Name or Date of Birth' });
          }
        });
      } else {
        console.log('Form Not Submitted!');
        // console.log(this.loginForm);
        Object.keys(this.loginForm.controls).forEach(control => {
          this.loginForm.controls[control].markAsDirty();
        });
      }
    }
  
    ngOnDestroy() {
      this.renderer.removeClass(document.body, 'login-body');
    }

    onInputDate(event): void {
      let cursorPosition = event.target.selectionEnd;
  
      if (event.inputType === 'deleteContentBackward' && (cursorPosition === 2 || cursorPosition === 5)) {
        event.target.value = event.target.value.substring(0, cursorPosition - 1) + event.target.value.substring(cursorPosition);
        cursorPosition--;
      }
      if (event.inputType === 'insertText' && (event.target.value.length > 10)) {
        event.target.value = event.target.value.substring(0, event.target.value.length - 1);
      }
  
      this.dateMask = event.target.value.toString();
      this.dateMask = this.dateMask.replace(/\D/g, '');
  
      let mask = '';
      for (let i = 0; i < this.dateMask.length; i++) {
        mask += this.dateMask[i];
        if (i === 1 || i === 3) {
          mask += '/';
          if (cursorPosition === 2 || cursorPosition === 5) { cursorPosition++; }
        }
      }
      event.target.value = mask.toString();
      event.target.selectionStart = cursorPosition;
      event.target.selectionEnd = cursorPosition;
  
      if (event.target.value.length === 10) {
        this.value = event.target.value;
        this.storedDate = this.value;
        
      }
    }
  
    onBlurDate(): void {
      // console.log(this.value);
      const d = new Date(Date.parse(this.loginForm.value.dateOfBirth));
      if (this.value == undefined) {
        this.storedDate = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
        // console.log(this.storedDate);
      } else {
        this.storedDate = this.value;
        // console.log(this.storedDate);
      }
     
    }

}



// WEBPACK FOOTER //
// ./src/app/paymentlogin/paymentlogin.component.ts